import { readonly, reactive, watchEffect } from 'vue'
import { api } from './api'
import { t } from './i18n'

const state = reactive({
  coupleNames: 'Esra & Tommy',
  weddingDate: '28. August 2026',
  weddingDateIso: '2026-08-28',
  siteUrl: window.location.origin,
  uploadLimits: {
    imageMb: 250,
    videoMb: 10240,
    batchMb: 51200,
    filesPerBatch: 50,
  },
})

export async function loadSiteConfig() {
  try {
    const loaded = await api<{
      coupleNames: string
      weddingDate: string
      weddingDateIso?: string
      siteUrl: string
      uploadLimits: { imageMb: number; videoMb: number; batchMb: number; filesPerBatch: number }
    }>('/api/config')

    Object.assign(state, loaded, {
      // Never replace the usable browser origin with an empty Coolify value.
      siteUrl: loaded.siteUrl?.trim() || window.location.origin,
    })
  } catch {
    // The exact design defaults stay usable while the API is temporarily offline.
  }
}

export const site = readonly(state)

watchEffect(() => {
  document.title = t('meta.title', { names: state.coupleNames })
})
